const Footer = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: 10,
      }}
    >
      Made with ♥ by{" "}
     
    </div>
  );
};

export default Footer;
